import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row } from 'react-bootstrap';
import DashboardTable from './dashboardtable/DashboardTable';
import { fetchTvDashboardData } from './TvDashboardActions';

function TvDashboard() {
  const items = useSelector((state) => state.tvDashboard.get('tvDashboardData'));

  const dispatch = useDispatch();
  useEffect(() => {
    const interval = setInterval(() => dispatch(fetchTvDashboardData()), 5000);
    dispatch(fetchTvDashboardData());
    return () => {
      clearInterval(interval);
    };
  }, [dispatch]);

  return (
    <Container fluid>
      <Row className="pt-3">
        <DashboardTable data={{ items, total: items.length }} />
      </Row>
    </Container>
  );
}

export default TvDashboard;
